import { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../common/components/Button'
import { LoadingSpinner } from '../../../common/components/LoadingSpinner'
import { ChatContext } from '../../../chat/context/ChatContext'
import { PreviewEditsContext } from '../model/PreviewEditsContext'
import { buildRecalculateRequest } from '../model/buildRecalculateRequest'
import { apiClient } from '../../../api/ApiClient'

export const PreviewRecalculateButton: FC<{ className?: string; disabled?: boolean; big?: boolean }> = ({
  className,
  disabled,
  big,
}) => {
  const { t } = useTranslation()
  const { chatId } = useContext(ChatContext)
  const { items } = useContext(PreviewEditsContext)
  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    const request = buildRecalculateRequest(items)
    setLoading(true)
    apiClient.chats.recalculate(chatId, request).finally(() => setLoading(false))
  }

  return (
    <Button
      className={className}
      primary
      big={big}
      disabled={disabled || loading || items.length === 0}
      onClick={handleClick}
    >
      {loading ? <LoadingSpinner /> : t('Recalculate and Save progress')}
    </Button>
  )
}
